module.exports = __webpack_public_path__ + "static/media/sucess-check.a1b6a7e6.png";